import React, { useState, useEffect, useRef, useContext } from 'react';
import '../../assets/css/views/login.css'
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/provider/UserProvider'
import { SocketContext } from '../../context/provider/SocketProvider'
import CryptoJS from 'crypto-js';

import { notify } from '../../utils/utils'
import logo from '../../assets/images/LogoAbexa2018.png'


const urlProyecto  = process.env.REACT_APP_XPROJECT_API
export const iniciarSesion = async (user, password, signIn) => {
    // const response = await fetch(urlProyecto + '/User/login?' + new URLSearchParams ({
    const response = await fetch('https://xprojectwebapi.abexacloud.com/api/User/login?' + new URLSearchParams ({
        usuario: user,
        clave:   password
    }), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    }).then(res => res.json());

    if (response.isValid) {
        signIn({
            ...response.content,
            token:'token',
            tokenExpire: 1000
        });
        return {isValid: true, data: response.content}
    }

    return {isValid: false, exceptions: response.exceptions[0].description}
}

const useLogin = (props) => {
    const inputUsuario = useRef();
    const history = useHistory();
    const { stateUser, signIn } = useContext(UserContext);
    const { mqttConnect } = useContext(SocketContext);
    const [ user, setUser ] = useState();
    const [ password, setPassword ] = useState();
    const [datosAcceso, setDatosAcceso] = useState(props.acceso);

    useEffect (() =>{
        setDatosAcceso(props.acceso);
        props.acceso && ingresarRedireccionamiento()
    }, [props.acceso]);

    const decifrado = datosAcceso? atob(datosAcceso) : null
    const decifradoAcceso= JSON.parse(decifrado);

    const descifrarDatosAcceso = (datosAcceso) => {
        if (!datosAcceso) return null;

        const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
        if (!base64Regex.test(datosAcceso)) return null;

        try {
            const descifrado = atob(datosAcceso);
            const objetoDescifrado = JSON.parse(descifrado);
            return typeof objetoDescifrado === 'object' && objetoDescifrado !== null ? objetoDescifrado : null;
        } catch (e) {
            return null;
        }
    };

    const iniciarSesionConRedireccion = async (usuario, clave) => {
        const ingreso = await iniciarSesion(usuario, clave, signIn);
        if (ingreso.isValid) {
            history.push('/bienvenido');
        } else {
            notify(ingreso.exceptions, 'error');
            history.push('/login');
        }
    }

    const ingresarRedireccionamiento = async () => {
        const accesoDescifrado = descifrarDatosAcceso(datosAcceso);
        if (accesoDescifrado) {
            await iniciarSesionConRedireccion(accesoDescifrado.usuario, accesoDescifrado.clave);
        }
    }

    const ingresar = async (e) => {
        e.preventDefault();
        const passHasheada = CryptoJS.SHA1(password).toString(CryptoJS.enc.Hex);
        await iniciarSesionConRedireccion(user, passHasheada);
    }

    return {
        user,
        setUser,
        password,
        setPassword,
        ingresar,
        inputUsuario,
        stateUser
    }
}

export const Login = (props) => {
    const login = useLogin(props);
    const history = useHistory()
    useEffect(() => {
        const datosSesion = window.localStorage.getItem('pm-session');
        datosSesion && history.push('/bienvenido')
    },[])

    return (

        <div className="flex flex-col dark:bg-slate-900 h-screen">

            <div className="h-[56px] flex items-center justify-start lg:justify-center " style={{background:'#002A78'}}>
                <div className="flex-shrink-0 flex justify-center items-center" style={{ width: '250px'}}>
                    <img className="w-[90px] h-full block sm:w-52 w-auto" src={logo} alt="Workflow"/>
                </div>
            </div>
            <div className="grow container flex justify-center items-center gap-x-10">
                <div className="w-[300px] mb-[90px] lg:w-[80%] flex flex-col items-center justify-between">
                    <div className="" style ={{}}>
                        <img src={logo} alt='' style={{marginBottom:'25px'}}/>
                    </div>
                    <div className="w-full border border-[#002A78] rounded" >
                        <div style={{textAlign:'center',borderBottom:'1px solid #002A78'}}>
                            <h2 className="dark:text-white text-base font-medium tracking-tight" >Inicio de Sesión.</h2>
                        </div>
                        <form onSubmit={(e)=> login.ingresar(e)}>
                            <div className="form flex flex-col py-10 text-center w-full">
                                <div className="input-wrapper" style={{marginBottom:'20px'}}>
                                    <input ref={login.inputUsuario} onChange={(e) => login.setUser(e.target.value)} defaultValue={login.user} className=" caret-black	 input h-10 focus:outline-none focus:ring focus:ring-blue-500 rounded" placeholder="Usuario"/>
                                    <i className="fa fa-user input-icon" aria-hidden="true"></i>
                                </div>

                                <div className="input-wrapper" style={{}}>
                                    <input type="password" onChange={(e) => login.setPassword(e.target.value)} defaultValue={login.password} className=" caret-black input h-10 focus:outline-none focus:ring focus:ring-blue-500 rounded" placeholder="Contraseña"/>
                                    <i className="fa fa-lock input-icon" aria-hidden="true"></i>
                                </div>
                            </div>
                                <div className="content-buttons mt-4" style={{textAlign:'center'}}>
                                    <button type='submit' className="dark:bg-blue-500 hover:bg-blue-600  text-white py-1 rounded"style={{borderRadius:'15px',width:'60%',height:'40px'}}>
                                        Ingresar
                                    </button>
                                <div className='dark:text-white' style={{textAlign:'center',margin:'20px'}}>
                                    <label style={{cursor:'pointer'}}>Olvidé mi Contraseña</label>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}


